import {isNullOrUndefined} from "../../../services/Validator";
import {kSystemIcons} from "../../../constants/icons";

export default function LevelABrevetSticker({isForBrevet}) {
    // Used in LevelAMetaData to display whether LevelA is for
    // brevet

    // BUILD
    if (isNullOrUndefined(isForBrevet) || isForBrevet === false)
        return null
    return (
        <div className={"ml-[16px] mt-[4px] bg-greenStar/30 flex justify-center items-center space-x-[6px] rounded-full px-[12px] py-[2px]"}>
            <i className="-ml-[3px] material-icons text-[14px] text-greenStar">
                {kSystemIcons.school}
            </i>
            <span className={"text-greenStar text-[14px] font-medium"}>
                {"Brevet"}
            </span>
        </div>
    );
}